/**
 * RESPONSIBILITY: draw a band of questions with answers that open.
 *
 * <details>, not a scripted accordion: it opens without JavaScript and the browser's own
 * find-in-page reaches a closed answer. The same markup and classes an event's questions use.
 */
import { Html } from '@framework/react';
import { idOf } from '@framework/core';
import { BandFrame } from './BandFrame';
import type { BandDef, BandProps } from './kind';

const asked = (b: BandProps['b']) => (b.questions ?? []).filter((q) => q.question);

function Draw({ b, tinted }: BandProps) {
  return (
    <BandFrame tinted={tinted} heading={b.heading}>
      <div className="ev-faq">
        {asked(b).map((q) => (
          <details key={idOf(q)}>
            <summary>{q.question}</summary>
            {q.answerHtml ? <Html className="md-body">{q.answerHtml}</Html> : null}
          </details>
        ))}
      </div>
    </BandFrame>
  );
}

export const faq: BandDef = { has: (b) => asked(b).length > 0, Draw };
